import { notEmpty, typeUtils } from '@festina-life/core'

/**
 * @param thingToClean  the object to clean
 * @param propertyFilter  callback invoked on all property values to filter them out as needed
 * @returns a new object where all properties that are empty strings or undefined are removed. It also cleans up empty objects and arrays.
 */
export const sanitizeFormData = <T>(
  thingToClean: T,
  propertyFilter: (value: unknown) => boolean = typeUtils.isMeaningfulFormValue,
): T | undefined => {
  if (Array.isArray(thingToClean)) {
    const cleanedArray = thingToClean.map((x) =>
      sanitizeFormData(x, propertyFilter),
    )

    return cleanedArray.filter(notEmpty) as T
  } else if (
    typeof thingToClean === 'object' &&
    thingToClean !== null &&
    !(thingToClean instanceof File)
  ) {
    const propertiesToclean = Object.entries(thingToClean)
    const cleanedProperties = propertiesToclean.map(([key, value]) => [
      key,
      sanitizeFormData(value, propertyFilter),
    ])
    const cleanedObject = Object.fromEntries(
      cleanedProperties.filter(([, value]) => propertyFilter(value)),
    )

    if (Object.keys(cleanedObject).length > 0) {
      return cleanedObject
    }

    return undefined
  } else if (typeof thingToClean === 'string') {
    return thingToClean === '' ? undefined : thingToClean
  }

  return thingToClean
}
